import { render, staticRenderFns } from "./CellProperties.vue?vue&type=template&id=a08e4c80"
import script from "./CellProperties.vue?vue&type=script&lang=js"
export * from "./CellProperties.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports